import React, { useState, useContext } from 'react';
import { motion } from 'framer-motion';

import Card from '../../shared/components/UIElements/Card';
import Button from '../../shared/components/FormElements/Button/Button';
import Modal from '../../shared/components/UIElements/Modal';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import './Interview.css';


const Interview = props => {

    const auth = useContext(AuthContext);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const {isLoading, error, sendRequest, clearError} = useHttpClient();

    const showDeleteModalHandler = () => {
        setShowDeleteModal(true);
    };

    const closeDeleteModalHandler = () => {
        setShowDeleteModal(false);
    };

    const confirmDeletionHandler = async () => {
        setShowDeleteModal(false);
        try {
            await sendRequest(process.env.REACT_APP_BACKEND_URL_PLAN+`/interview/${props.id}/delete`, 'DELETE', null, {Authorization:'Bearer '+auth.token});
            props.onDelete(props.id);
        } catch (err) {

        }
    };

    return (
    <React.Fragment>
    <ErrorModal error={error} onClear={clearError} />
    <Modal
    show={showDeleteModal}
    onCancel={closeDeleteModalHandler}
    header="Are you sure?"
    footerClass="interview-item__modal-actions"
    footer={
      <React.Fragment>
        <Button inverse onClick={closeDeleteModalHandler}>
          CANCEL
        </Button>
        <Button danger onClick={confirmDeletionHandler}>
          DELETE
        </Button>
      </React.Fragment>
    }
    >
        <p>You can never undo delete. Are you sure you want to delete the interview?</p>
    </Modal>
    <motion.li 
        className="interview-item"
        initial={{ opacity: 0, x: -1200 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.25+0.1*props.index, duration: 1 }}
    >
        <Card className="interview-item__content">
            {isLoading && <LoadingSpinner asOverlay />}
                <Button to={`/interview/${props.id}/questions`} transparent_100>
                <h3 style={{ width: '100%' }}>{props.title}</h3>
                </Button>
        </Card>
    </motion.li>
    </React.Fragment>
    );

};

export default Interview;